import useToastContext from 'hooks/useToastContext'
import { apiPut } from '../../utils/apiFetch'
import { useTranslation } from 'react-i18next'
import apiPath from '../../utils/apiPath'
import { useContext } from 'react'
import { isEmpty, startCase } from 'lodash'
import helper from '../../utils/helpers'
import AuthContext from 'context/AuthContext'

const PropertyTypesList = ({
  categoryList,
  paginationObj,
  allCategory,
  manager
}) => {
  const notification = useToastContext()
  const { t } = useTranslation()

  const { user } = useContext(AuthContext)

  const handelStatusChange = async item => {
    try {
      const payload = {
        status: item?.status === 'inactive' ? 'active' : 'inactive'
      }
      const path = `${apiPath.changePropertyTypesStatus}/${item?._id}`
      const result = await apiPut(path, payload)
      if (result?.status === 200) {
        notification.success(result.data.message)
        allCategory()
      }
    } catch (error) {
      console.log('error in get all category list==>>>>', error.message)
    }
  }

  return (
    <div>
      <div className='p-3'>
        <div className='overflow-x-auto relative 
 border'>
          <table className='w-full text-xs text-left text-[#A5A5A5] dark:text-gray-400 '>
            <thead className='text-xs text-gray-900 border border-[#E1E6EE] bg-[#E1E6EE] dark:bg-gray-700 dark:text-gray-400'>
              <tr>
                <th scope='col' className='py-3 px-6'>
                  #
                </th>
                <th scope='col' className='py-3 px-6'>
                  {t('O_TYPE')}
                </th>
                <th scope='col' className='py-3 px-6'>
                  {t('O_TYPE') + t('O_ARABIC')}
                </th>
                {(manager?.add || user?.role === 'admin') && (
                  <th scope='col' className='py-3 px-6 text-center'>
                    {t('O_STATUS')}
                  </th>
                )}
              </tr>
            </thead>

            <tbody>
              {categoryList &&
                categoryList.length > 0 &&
                categoryList.map((item, i) => {
                  return (
                    <tr
                      key={i}
                      className='bg-white border-b dark:bg-gray-800 dark:border-gray-700'
                    >
                      <th
                        scope='row'
                        className='py-2 px-2 border-r font-medium text-gray-900  dark:text-white'
                      >
                        {i + 1 + 10 * (paginationObj?.page - 1)}
                      </th>
                      <td className='py-2 px-2 border-r'>
                        {startCase(item?.name)}
                      </td>
                      <td className='py-2 px-2 border-r'>{item?.nameAr}</td>
                      {(manager?.add || user?.role === 'admin') && (
                        <td className='py-2 px-2 border-r text-center'>
                          <label
                            className='inline-flex relative items-center cursor-pointer'
                            title={`${
                              item?.status === 'active' ? 'Active' : 'Inactive'
                            }`}
                          >
                            <input
                              type='checkbox'
                              className='sr-only peer'
                              checked={item?.status === 'active'}
                              onChange={e =>
                                helper.alertFunction(
                                  `Are you sure want to ${
                                    e.target.checked ? 'active' : 'inactive'
                                  } ${item.name}?`,
                                  item,
                                  handelStatusChange
                                )
                              }
                            />
                            <div className="w-10 h-5 bg-gray-200 rounded-full peer peer-focus:ring-0 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-[#8FC150]" />
                          </label>
                        </td>
                      )}
                    </tr>
                  )
                })}
              {isEmpty(categoryList) && (
                <tr className='bg-white border-b text-center dark:bg-gray-800 dark:border-gray-700'>
                  <td className='py-2 px-2 border-r' colSpan={6}>
                    {t('O_NO_RECORD_FOUND')}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}

export default PropertyTypesList
